import React from 'react';

const StartLine: React.FC = () => {
  return <div className="start-line"></div>;
};

export default StartLine;
